import { isNil } from 'lodash'
import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { expandLeftToolbar } from '../../../action/left-toolbar-state-actions'
import activeVendors from '../../../reducer/activeVendors'
import { collapseLeftToolbar } from '../../../action/left-toolbar-state-actions'
import { createContent, buildContent } from '../infoWindow'
import { infoWindowOpenAction, infoWindowCloseAction } from '../../../action/infowindow-action'
import { selectedObjectId, selectedObjectIdNull } from '../../../action/map-object-id'
import sharedCluster, { createInvisibleMarker, rebuildCluster } from '../sharedMarkerCluster'
import { normalizeTrackWidth } from '../../../lib/trackColor'
import { contentVisibilityKey } from '../../../action/hidden-content-ids-actions'
import { visibleActiveVendors } from '../../../lib/layerVisibility'

const RenderPolygons = (props) => {
  const [disableObj, setDisabelObj] = useState(props.disableMapObj.disableMapObject)
  const [infowindowsState, setInfowindowsState] = useState(null)
  const [previousState, setPreviousState] = useState(null)
  let { infoWindowOpenAction, infoWindow, selectedObjectId, selectedObjectIdNull } = props
  const polygonRefs = useRef({});
  const polygonClusterMarkersRef = useRef([]);
  const polygonMarkerMapRef = useRef({});
  let openInfoWindow = null;

  // Cleanup when polygons are deleted from Redux state
  useEffect(() => {
    if (!props.mapReference) return;
    const currentIds = new Set(props.polygons.map(p => p.id));
    const removedIds = Object.keys(polygonRefs.current).filter(id => !currentIds.has(Number(id)));
    if (removedIds.length === 0) return;
    removedIds.forEach(id => {
      polygonRefs.current[id].setMap(null);
      delete polygonRefs.current[id];
      const invisibleMarker = polygonMarkerMapRef.current[id];
      if (invisibleMarker) {
        invisibleMarker.map = null;
        sharedCluster.polygonMarkers = sharedCluster.polygonMarkers.filter(m => m !== invisibleMarker);
        delete polygonMarkerMapRef.current[id];
      }
    });
    rebuildCluster(props.mapReference);
  }, [props.polygons]);

  // My Content per-type show/hide for shapes. When "shapes" is hidden, remove each
  // user polygon's shape + its cluster proxy and clear mapObj so the render-body
  // diff re-draws it when shapes are shown again. Only user polygons (props.polygons)
  // are touched; vendor shapes are unaffected. Proxy removal is required because
  // shapes are shown via the cluster's clusteringend handler, not setMap alone.
  useEffect(() => {
    if (!props.mapReference) return;
    if (!props.hiddenContentTypes.includes('shapes')) return;
    let changed = false;
    props.polygons.forEach(polygon => {
      const id = polygon.id;
      if (polygonRefs.current[id]) {
        try { polygonRefs.current[id].setMap(null) } catch (e) { /* already gone */ }
        delete polygonRefs.current[id];
      }
      const invisibleMarker = polygonMarkerMapRef.current[id];
      if (invisibleMarker) {
        invisibleMarker.map = null;
        sharedCluster.polygonMarkers = sharedCluster.polygonMarkers.filter(m => m !== invisibleMarker);
        polygonClusterMarkersRef.current = polygonClusterMarkersRef.current.filter(m => m !== invisibleMarker);
        delete polygonMarkerMapRef.current[id];
        changed = true;
      }
      if (polygon.mapObj) {
        try { polygon.mapObj().setMap(null) } catch (e) { /* already gone */ }
        polygon.mapObj = null;
        changed = true;
      }
    });
    if (changed) rebuildCluster(props.mapReference);
  }, [props.hiddenContentTypes, props.mapReference, props.polygons]);

  // My Content per-OBJECT hide (WEB-7047). Remove individually-hidden polygons and
  // clear mapObj so the render-body below re-draws them when shown again.
  useEffect(() => {
    if (!props.mapReference) return;
    let changed = false;
    props.polygons.forEach(polygon => {
      if (!props.hiddenContentIds.includes(contentVisibilityKey('polygon', polygon.id))) return;
      const id = polygon.id;
      if (polygonRefs.current[id]) {
        try { polygonRefs.current[id].setMap(null) } catch (e) { /* already gone */ }
        delete polygonRefs.current[id];
      }
      const invisibleMarker = polygonMarkerMapRef.current[id];
      if (invisibleMarker) {
        invisibleMarker.map = null;
        sharedCluster.polygonMarkers = sharedCluster.polygonMarkers.filter(m => m !== invisibleMarker);
        polygonClusterMarkersRef.current = polygonClusterMarkersRef.current.filter(m => m !== invisibleMarker);
        delete polygonMarkerMapRef.current[id];
        changed = true;
      }
      if (polygon.mapObj) {
        try { polygon.mapObj().setMap(null) } catch (e) { /* already gone */ }
        polygon.mapObj = null;
        changed = true;
      }
    });
    if (changed) rebuildCluster(props.mapReference);
  }, [props.hiddenContentIds, props.mapReference, props.polygons]);

  useEffect(() => {
    if (previousState) {
      previousState.close()
    }
    setPreviousState(infowindowsState)
  }, [infowindowsState])

  let storeInfoBox = (value) => {
    setInfowindowsState(value);
    infoWindowOpenAction(value)
  }
  useEffect(() => {
    props.polygons.forEach(polygon => {
      if (polygon.mapObj) {
        polygon.mapObj().setOptions({ clickable: props.disableMapObj.disableMapObject });
      }
    });
    setDisabelObj(props.disableMapObj.disableMapObject)
  }, [props.disableMapObj.disableMapObject, props.polygons]);
  const { expandLeftToolbar, polygons, mapReference, activeVendors, vendors, collapseLeftToolbar, hiddenContentTypes, hiddenContentIds } = props,
    hideShapes = hiddenContentTypes.includes('shapes'),
    vendorPolys = activeVendors.map(id => {
      return vendors[id] && vendors[id]['objects'] && vendors[id]['objects']['polygons'] ?
        vendors[id]['objects']['polygons'].filter(poly => isNil(poly.mapObj) && !isNil(poly.geoJson)) : []
    }),
    toAdd = (hideShapes ? [] : polygons.filter(poly => isNil(poly.mapObj) && !hiddenContentIds.includes(contentVisibilityKey('polygon', poly.id)))).concat(vendorPolys.flat())
  if (!isNil(mapReference) && toAdd.length > 0) {
    const shapeData = [];
    toAdd.forEach(polygon => {
      polygon['measureType'] = 'polygon'
      if (!polygon.geoJson) {
        return
      }

      if (!polygonRefs.current[polygon.id]) {  // Only add marker if not already on the map
      } else {
        polygonRefs.current[polygon.id].setMap(null)
        delete polygonRefs.current[polygon.id];
      }
      const geoJson = JSON.parse(polygon.geoJson),
        coords = geoJson.features[0].geometry.coordinates[0].map(coord => new google.maps.LatLng(coord[1], coord[0])),
        mappoly = new google.maps.Polygon({
          name: polygon.name,
          map: null,
          path: coords,
          strokeColor: geoJson.features[0]?.properties?.line?.color || '#fff'
            ? geoJson.features[0]?.properties?.line?.color?.length == 9
              ? '#' + geoJson.features[0].properties?.line?.color.substring(3, 9)
              : geoJson.features[0].properties?.line?.color
            : '#0009F9',
          fillColor: geoJson.features[0].properties?.line?.color
            ? geoJson.features[0].properties?.line?.color.length == 9
              ? '#' + geoJson.features[0].properties?.line?.color.substring(3, 9)
              : geoJson.features[0].properties?.line?.color
            : '#0009F9',
          strokeOpacity: 1,
          strokeWeight: normalizeTrackWidth(geoJson.features[0]?.properties?.line?.width),
          zIndex: 10,
          options: {
            draggable: false,
            clickable: true,
            cursor: 'pointer'
          }
        })
      polygon['mapObj'] = function () { return mappoly }
      mappoly.setOptions({ clickable: disableObj });
      mappoly.addListener('click', (event) => {
        selectedObjectId(polygon.id)
        const latLng = event.latLng;
        const lat = latLng.lat();
        const lng = latLng.lng();
        let infoPosition = { lat: lat, lng: lng }
        let editFunction = (infoWindow) => {
          closeFunction(infoWindow)
          // infoWindowOpenAction(null)
          collapseLeftToolbar()
          expandLeftToolbar({ dialog: 'edit', editable: polygon })
          selectedObjectIdNull()
        }

        const closeFunction = (infoWindow) => {
          openInfoWindow = infoWindow;
          openInfoWindow.close();
          // infoWindowOpenAction(null)
          setInfowindowsState(null)
          selectedObjectIdNull()
        }

        const updateInfoWindow = (value) => {
          openInfoWindow = value
        }

        const dispatchFunction = (value) => {
          storeInfoBox(value)
        }

        createContent({ shapeDetails: polygon, mapObj: mappoly, infoWindow, type: 'poly', infoPosition }, { editFunction, closeFunction, updateInfoWindow }, dispatchFunction);
      })
      polygonRefs.current[polygon.id] = mappoly;
      const rawCoords = geoJson.features[0].geometry.coordinates[0];
      const avgLat = rawCoords.reduce((sum, c) => sum + c[1], 0) / rawCoords.length;
      const avgLng = rawCoords.reduce((sum, c) => sum + c[0], 0) / rawCoords.length;
      shapeData.push({ id: polygon.id, pos: { lat: avgLat, lng: avgLng }, shape: mappoly });
    });

    polygonClusterMarkersRef.current.forEach(m => { m.map = null; });
    Promise.all(shapeData.map(({ pos }) => createInvisibleMarker(pos))).then(markers => {
      const validMarkers = [];
      markers.forEach((m, i) => {
        if (!m) return; // shape had invalid geoJson coordinates; skip it (WEB-7033)
        m._shape = shapeData[i].shape;
        polygonMarkerMapRef.current[shapeData[i].id] = m;
        validMarkers.push(m);
      });
      polygonClusterMarkersRef.current = validMarkers;
      sharedCluster.polygonMarkers = validMarkers;
      rebuildCluster(mapReference);
    });
  }
  return null
}

const mapStateToProps = state => ({
  // Hidden by the global layers eye toggle along with the layers they came from (WEB-7048).
  activeVendors: visibleActiveVendors(state),
  vendors: state.vendors,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  polygons: state.polygons,
  disableMapObj: state.disableMapObj,
  infoWindow: state.infoWindow,
  hiddenContentTypes: state.hiddenContentTypes,
  hiddenContentIds: state.hiddenContentIds
})

const mapDispatchToProps = dispatch => ({
  expandLeftToolbar: props => dispatch(expandLeftToolbar(props)),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  infoWindowOpenAction: (payload) => dispatch(infoWindowOpenAction(payload)),
  selectedObjectId: (payload) => dispatch(selectedObjectId(payload)),
  selectedObjectIdNull: () => dispatch(selectedObjectIdNull()),
})

export default connect(mapStateToProps, mapDispatchToProps)(RenderPolygons)